import {all} from 'redux-saga/effects';
import authSagas from './Auth';
import menuSagas from './Menu';
import packagesSaga from './Packages';
import manageSaga from './UserManage';
import userSaga from './User';
import masterDriver from './MasterDriver';
import masterVehicle from './MasterVehicle';
import notifSaga from './Notif';

export default function* rootSaga(getState) {
    yield all([
        authSagas(),
        menuSagas(),
        packagesSaga(),
        manageSaga(),
        userSaga(),
        masterDriver(),
        masterVehicle(),
        notifSaga()
    ]);
}



// WEBPACK FOOTER //
// ./sagas/index.js